import { render, staticRenderFns } from "./LessStock.vue?vue&type=template&id=f056311c"
import script from "./LessStock.vue?vue&type=script&lang=js"
export * from "./LessStock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports